import React from 'react';
import { McpOnly } from '../../Components/Permissions';
import { SupportLink } from '../../Components/SupportLink';
import { Text } from '../../globalStyles';
import { PageTitle } from '../Shared';

export const SettingsPageTitle = () => {
  return (
    <div className="pa4 ml2 bg-white">
      <PageTitle>Settings</PageTitle>
      <McpOnly>
        <Text.bodySmall className="mt2">
          Questions regarding your account? <SupportLink>Contact us</SupportLink>
        </Text.bodySmall>
      </McpOnly>
    </div>
  );
};
